import { CreateUserRequestDto } from '@tradgine/data-access/auth';
import { CreateOrganizationUser } from '../domain/create-organization-user.model';

export function toCreateUserRequestDto(model: CreateOrganizationUser): CreateUserRequestDto {
    return {
        organizationId: model.organizationId,
        id: null,
        login: model.login,
        fullName: model.fullName,
        email: model.email,
        phoneNumber: model.phoneNumber,
        position: model.position,
        roles: model.roles,
        status: null,
    };
}
